import AuthService from "../services/auth.service";

export const auth = {
  namespaced: true,
  state: {
    isAuthenticated: !!localStorage.getItem("access_token"),
    user: JSON.parse(localStorage.getItem("user")) || null,
  },
  mutations: {
    setAuth(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    setUser(state, user) {
      state.user = user;
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      } else {
        localStorage.removeItem("user");
      }
    },
  },
  actions: {
    async login({ commit, dispatch }, credentials) {
      console.log('🚀 [Auth] Iniciando proceso de login...');
      try {
        console.log('🔍 [Auth] Llamando a AuthService.login');
        const response = await AuthService.login(credentials);
        console.log('✅ [Auth] Login exitoso, respuesta:', response);

        // Guardar toda la respuesta del usuario incluyendo roles_with_descriptions
        const userData = {
          ...response.user,
          roles: response.roles,
          roles_with_descriptions: response.roles_with_descriptions,
          permissions: response.permissions,
          application: response.application,
          is_super_admin: response.is_super_admin
        };

        // Primero guardamos en localStorage ANTES de actualizar el estado
        localStorage.setItem("access_token", response.token);
        localStorage.setItem("user", JSON.stringify(userData));

        // Ahora actualizamos el estado - orden importante
        commit("setUser", userData);
        commit('setUser', userData, { root: true });
        commit("setAuth", true);

        // Cargar información de suscripción y módulos
        try {
          console.log('🔍 [Auth] Cargando suscripción desde login...');
          console.warn('⚠️ IMPORTANTE: A punto de llamar fetchEffectiveSubscription');

          const result = await dispatch('subscription/fetchEffectiveSubscription', null, { root: true });
          console.log('🔍 [Auth] Suscripción cargada exitosamente:', result);
          console.log('✅ [Auth] Resultado del fetch:', result);

          console.log('🔍 [Auth] Cargando módulos activos...');
          await dispatch('subscription/fetchActiveModules', { per_page: 100 }, { root: true });
          console.log('🔍 [Auth] Módulos cargados exitosamente');
        } catch (error) {
          console.error('❌ [Auth] Error cargando información de suscripción:', error);
          console.error('❌ [Auth] Error completo:', JSON.stringify(error, null, 2));
          // No lanzamos error para no interrumpir el login
        }

        // Pequeño delay para asegurar que el estado se propagó
        await new Promise(resolve => setTimeout(resolve, 100));

        return response;
      } catch (error) {
        commit("setAuth", false);
        commit("setUser", null);
        localStorage.removeItem("access_token");
        localStorage.removeItem("user");
        throw error;
      }
    },
    async logout({ commit, dispatch }) {
      await AuthService.logout();
      commit("setAuth", false);
      commit("setUser", null);
      localStorage.removeItem("access_token");

      // También limpiar el store principal
      commit('setUser', {}, { root: true });

      // Limpiar información de suscripción
      dispatch('subscription/clearSubscription', null, { root: true });
    },
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    user: (state) => state.user,
  },
};
